export default __webpack_public_path__ + "43e76466832495fbb8104ca29459968c.png";